module.exports = __webpack_public_path__ + "static/media/festival_01.42a68d89.jpg";